export default __webpack_public_path__ + "4ece9f5ded180657814d3f5f3422f08e.webp";